/*
 * WanderS - Shopify Forms light/dark theming
 * ==========================================
 * The trade-account sign-up form is the Shopify Forms app block. The app renders
 * it inside an open shadow root (<shopify-forms-embed>) and sets its colours as
 * CSS variables on :host, from fixed values in the block settings (#202020 text,
 * dark button). Theme CSS cannot reach into a shadow root, so the form ignored
 * the Light/Dark toggle and its dark text sat on the dark page.
 *
 * Fix: hand each form one extra stylesheet that points the app's own colour
 * variables at the theme's mode tokens (--cm-*, assets/wanders-color-mode.css).
 * Custom properties inherit through the shadow boundary, so when color-mode.js
 * flips html[data-color-mode] the form re-colours instantly - no re-render.
 *
 * Only colours change. Fields, validation, submission, captcha and the app's
 * layout are untouched. Fallback values match the Light palette.
 */
(function () {
  if (window.__wandersFormsTheme) return;
  window.__wandersFormsTheme = true;

  var CSS =
    ':host{' +
    'color-scheme:inherit;' +
    '--heading-text-color:var(--cm-text-strong,#0b2b2a)!important;' +
    '--body-text-color:var(--cm-text,#173f3d)!important;' +
    '--subdued-text-color:var(--cm-muted,#526967)!important;' +
    '--link-text-color:var(--cm-accent,#1b6f6e)!important;' +
    '--forms-accent-color:var(--cm-accent,#1b6f6e)!important;' +
    '--form-text-color:var(--cm-text,#173f3d)!important;' +
    '--form-placeholder-color:var(--cm-muted,#526967)!important;' +
    '--form-background-color:var(--cm-surface,#ffffff)!important;' +
    '--form-error-color:var(--cm-error-fg,#8a2a1e)!important;' +
    '--form-field-border:0 0 0 1px var(--cm-line-strong,rgba(23,63,61,.32))!important;' +
    '--form-field-border-focused:0 0 0 2px var(--cm-focus,#258585)!important;' +
    '--button-background-color:var(--cm-button-bg,#0b2b2a)!important;' +
    '--button-text-color:var(--cm-button-fg,#ffffff)!important;' +
    '--container-background-color:transparent!important;' +
    '--forms-discount-code-color:var(--cm-text,#173f3d)!important;' +
    '--forms-discount-code-background-color-hover:var(--cm-surface-2,#f6f8f7)!important;' +
    '--p-color-bg-surface:var(--cm-surface,#ffffff)!important;' +
    '--p-color-bg-surface-secondary:var(--cm-surface-2,#f6f8f7)!important;' +
    '--p-color-border-focus:var(--cm-focus,#258585)!important;' +
    '}';

  var sheet = null;
  try {
    sheet = new CSSStyleSheet();
    sheet.replaceSync(CSS);
  } catch (e) {
    sheet = null; /* older browsers: <style> fallback below */
  }

  function theme(el) {
    var root = el && el.shadowRoot;
    if (!root || root.__wandersThemed) return;
    root.__wandersThemed = true;
    if (sheet && 'adoptedStyleSheets' in root) {
      root.adoptedStyleSheets = root.adoptedStyleSheets.concat([sheet]);
    } else {
      var style = document.createElement('style');
      style.textContent = CSS;
      root.appendChild(style);
    }
  }

  function scan() {
    var forms = document.querySelectorAll('shopify-forms-embed');
    for (var i = 0; i < forms.length; i++) theme(forms[i]);
  }

  scan();
  document.addEventListener('DOMContentLoaded', scan);

  /* The app creates <shopify-forms-embed> asynchronously (inline and popup forms). */
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.localName === 'shopify-forms-embed') {
          theme(node);
        } else if (node.firstElementChild && node.querySelector('shopify-forms-embed')) {
          scan();
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
